export function getFieldHelperText(helperText: string | undefined, required: boolean): string | undefined {
  if (required) {
    return helperText ?? undefined;
  }
  return helperText ? `(Optional) ${helperText}` : "(Optional)";
}
